import { ACTIONS_OZON } from '../actions/ozon';

export const ozon = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_OZON.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_OZON.CHANGE_PRODUCT: {
      const { product } = action;
      return { ...state, byId: { ...state.byId, [product.offer_id]: { ...product } } };
    }
    case ACTIONS_OZON.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
